export const attachmentDecorator = data => ({
	attachmentId: data.attachmentId,
	attachmentType: data.attachmentType,
});

export const attachmentFormatter = data =>
	JSON.stringify({
		attachmentId: data.attachmentId,
		attachmentType: data.attachmentType,
	});

export const attachmentFilterDecorator = (current, incoming) => {
	return current.attachmentId === incoming.attachmentId && current.attachmentType === incoming.attachmentType;
};
